import React, { useEffect } from "react";
import { useState } from "react";
import { Table, Form } from "react-bootstrap";
import HTMLComponent from "../../../../components/HtmlComponent";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../../constants/index";
import { FaSpinner } from "react-icons/fa";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
const ViewJobDescription = () => {
  const { pageLoading, setPageLoading } = useState(true);
  const { JobDescriptionID } = useParams();
  const [JD, setJD] = useState("");
  // const history = useHistory();
  const navigate = useNavigate();
  useEffect(() => {
    fetchDetails();
  }, []);

  const fetchDetails = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}JobDescriptions/${JobDescriptionID}`
      );
      if (response.status === 200) {
        setJD(response?.data?.data?.Description);
      } else {
        console.error(
          "Failed to fetch job details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching job details:", error);
    }
    // }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Job Description"))
  }, [])
  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className="row mt-4">
           <div className="col-sm-10 offset-sm-1 expired-div" style={{ height: 'auto' }}>
            <h6 class="heading skill-heading text-center">Job Description</h6>
            <hr />
            <HTMLComponent html={JD} />
          </div>
          </div>
        </div>
      </>
    );
  }
};

export default ViewJobDescription;
